import { toLower } from "lodash";

import dayjs from "dayjs";

// used for FB advanced matching
import {
  getVisitEmail,
  getVisitFirstName,
  getVisitLastName,
  getVisitPhone,
  getVisitGender,
  getVisitUSState,
  getVisitBirthday,
  getUserID,
} from "../../visits/utils/visitCookies";

import posthog from "posthog-js";

import { builder } from "@builder.io/react";

export const AMPLITUDE_API_KEY_TESTING = "c5262200717040ec2ece24a5719f20be";
export const AMPLITUDE_APIKEY_PRODUCTION = "63dd68466f7f14c5cf6e16f5ed4b78aa";

export const BUILDER_IO_API_KEY = "8ed23e53ad6147b784de3ef824f5e5f4";

const EVENT_TYPE_DOCTOR_VISIT_START = "Doctor Visit Start";
const EVENT_TYPE_DOCTOR_VISIT_COMPLETE = "Doctor Visit Complete";
const EVENT_TYPE_DOCTOR_VISIT_CHECKOUT = "Doctor Visit Checkout";
const EVENT_TYPE_DOCTOR_VISIT_PRESCRIPTION_WRITTEN =
  "Doctor Visit Prescription Written";
const EVENT_TYPE_DOCTOR_VISIT_REFERRAL_PRIMARY_CARE =
  "Doctor Visit Referral Primary Care";
const EVENT_TYPE_REFILL_CHECKOUT = "Refill Checkout";

const EVENT_TYPE_PATIENT_CREATED = "Complete Registration";
const EVENT_TYPE_PATIENT_PORTAL_LOGIN = "Patient Portal Login";
const EVENT_TYPE_PATIENT_MESSAGE_SENT = "Patient Message Sent";

export const FB_PIXEL_ID = "1883879761863029";
export const FB_EVENT_PURCHASE = "Purchase";

export const GTM_EVENT_SIGNUP = "Signup";
export const GTM_EVENT_PURCHASE = "Purchase";

export const GA_CATEGORY_KITS = "Kits";
export const GA_CATEGORY_CONSULTATION = "Consultation";

export const GA_CATEGORY_SIGNUP = "Signup";

export function trackPatientPortalLogin() {
  // track(EVENT_TYPE_PATIENT_PORTAL_LOGIN);
}

export function trackRefillCheckout(userID) {
  // track(EVENT_TYPE_REFILL_CHECKOUT);
}

export function trackPatientMessageSent(userID) {
  // track(EVENT_TYPE_PATIENT_MESSAGE_SENT);
}

//--------------------------------------
// GTM & GA
export function gtmDataLayerPush(obj) {
  if (window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  }
}

export function gtmTrackGAEvent(
  eventCategory,
  eventAction,
  eventLabel,
  eventValue
) {
  gtmTrackCustomGTMGAEvent(
    "GAEvent",
    eventCategory,
    eventAction,
    eventLabel,
    eventValue
  );
}

export function gtmTrackCustomGTMGAEvent(
  eventName,
  eventCategory,
  eventAction,
  eventLabel,
  eventValue
) {
  gtmDataLayerPush({
    event: eventName,
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: eventValue,
  });
}

export function trackPurchaseGTM(obj) {
  console.log("trackPurchaseGTM: ", obj);
  gtmDataLayerPush(obj);
}

// -------------------------------
// FB

export function fbqReInit() {
  var bday = "";

  // parse visit birthday and format defensively.
  if (getVisitBirthday() != "") {
    const bdayJS = dayjs(getVisitBirthday());
    if (bdayJS.isValid()) {
      bday = bdayJS.format("YYYYMMDD");
    }
  }

  var phone = getVisitPhone();
  if (phone != "") {
    phone = "1" + phone; // facebook requires country code
  }

  if (window.fbq) {
    var initData = {
      em: toLower(getVisitEmail()).trim(),
      fn: toLower(getVisitFirstName()).trim(),
      ln: toLower(getVisitLastName()).trim(),
      ph: phone, // facebook requires country code
      ge: toLower(getVisitGender()).trim(),
      st: toLower(getVisitUSState()).trim(),
      db: bday, // facebook requires digits only with birth year, month, then day - 19910526 for May 26, 1991.
      country: "us",
      external_id: getUserID(),
    };
    console.log("initData: ", initData);
    window.fbq("init", FB_PIXEL_ID, initData);
  } else {
    console.log("fbq not available...");
  }
}

export function fbPixel(eventName, objProps) {
  if (window.fbq) {
    window.fbq("track", eventName, objProps);
  }
}

export function trackPurchaseFB(objProps) {
  fbPixel(FB_EVENT_PURCHASE, objProps);
}
// -------------------------------
// Kick Events

export function trackSignup(usState, consultationType) {
  gtmTrackCustomGTMGAEvent(
    GTM_EVENT_SIGNUP,
    GA_CATEGORY_SIGNUP,
    `${GTM_EVENT_SIGNUP} - ${usState}`,
    consultationType,
    1
  );

  //   fbPixel("CompleteRegistration", {
  //     value: 0,
  //     currency: "USD",
  //   });
}

export function trackKitStart(service) {
  gtmTrackGAEvent(GA_CATEGORY_KITS, "Kit Checkout Started", service, 1);
}

// ================= Klaviyo Events ====================================
export function identifyKlaviyoPatientSignUp(email, consultationType) {
  var _learnq = _learnq || [];
  _learnq.push([
    "identify",
    {
      $email: email,
      signup_consultation_type: consultationType,
    },
  ]);
}

export function identifyKlaviyoPatientLogin(email) {
  var _learnq = _learnq || [];
  _learnq.push([
    "identify",
    {
      $email: email,
    },
  ]);
}

// ----------------- End Klaviyo Events --------------------------------
// ================= Customer.io Events ====================================
export function identifyCustomerIOPatientSignUp(email, consultationType) {
  window._cio &&
    window._cio.identify({
      // Required attributes
      // id: 'user@domain.com',    // Use either cio_id, id, or email.
      email: email, // Use either cio_id, id, or email.

      // Strongly recommended attributes
      // created_at: 1339438758,   // Timestamp in your system that represents when
      // the user first signed up. You'll want to send it
      // as seconds since the epoch.

      // Example attributes (you can name attributes what you wish)
      signup_consultation_type: consultationType,
      // first_name: 'John',       // Add any attributes you'd like to use in the email subject or body.
      // last_name: 'Smith',       // First name and last name are shown on people pages.
    });
}

export function identifyCustomerIOPatientLogin(email) {
  window._cio &&
    window._cio.identify({
      email: email, // Use either cio_id, id, or email.
    });
}

// ----------------- End Customer.io Events --------------------------------

// ================= Posthog Events ====================================

export function posthogInit() {
  posthog.init("phc_OLS0YTqBd4MT0Ajo0mRyrdmCOOf041jFmARHtBYI2yi", {
    api_host: "https://disco.gokick.com",
    ui_host: "https://us.i.posthog.com",
    person_profiles: "always",
    enable_recording_console_log: true,
    disable_session_recording: false,
    capture_console_logs: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: { password: true },
    },
    enable_heatmaps: true,
  });

  // posthog.init("phc_XvJu50NNPlaR4Npg39SR8af9mXwW7KzUibnyIyTEsMV", {
  //   api_host: "https://disco.gokick.com",
  //   disable_session_recording: false,
  //   enable_recording_console_log: true,
  //   session_recording: {
  //     maskAllInputs: false,
  //     maskInputOptions: { password: true },
  //   },
  // });
}

export function posthogStartSessionRecording() {
  posthog.startSessionRecording(true);
}

export const identifyUser = (userID, ...args) => {
  posthog.identify(userID, ...args);
};

// ----------------- End Posthog Events --------------------------------
// ================= Builder.io Events ====================================

export function builderIOInit() {
  builder.init(BUILDER_IO_API_KEY);
}

export function trackBuilderConversion(value) {
  builder.trackConversion(value);
}

// ----------------- End Builder.io Events --------------------------------
// ================= VWO Events ====================================

export function trackVWOConversion(value) {
  window.VWO = window.VWO || [];
  window.VWO.push(["track.revenueConversion", value]);
}

// ----------------- End VWO Events --------------------------------
